<template>
  <div :style="'background: whitesmoke;'">
    <div class="main-container">
      <div class="d-flex justify-between mt-3 mx-1 pt-3">
        <div class="d-flex">
          <div class="cursor-pointer" @mouseover="isHovered = true" @mouseleave="isHovered = false">
            <div class="icon_hover">
              <q-img @click="goBack" :src="'/arrow.png'" @mouseover="isHovered = true"
                @mouseleave="isHovered = false" :style="'width:25px; height: 25px'" />
            </div>
          </div>
          <div>
            <span class="ml-3 font-family" :style="'font-size: 24px;'">Product Details</span>
          </div>
        </div>
        <div class="shop_card cursor-pointer">
          <div @mouseover="isHovered = true" @mouseleave="isHovered = false">
            <div class="icon_hover">
              <q-img @click="$router.push('/Partners/Stock/Cart')" :src="'/Cart.png'" @mouseover="isHovered = true"
                @mouseleave="isHovered = false" :style="'width:25px; height: 25px'" />
            </div>
          </div>
          <div v-if="cartData.length" class="card_number">
            {{ cartData.length }}
          </div>
        </div>
      </div>
  
      <div class="row mt-1">
        <div v-if="product" class="col-12 mb-1">
          <q-card class="">
            <div class="d-flex justify-center" :style="'align-items: center;'">
              <div class="q-pa-md mt-3 main-image-set">
                <div :style="'width: 250px; max-width: 250px; position: relative; display: inline-block;'">
                  <div class="image-container">
                    <img :src="imageUrl(product.images)" alt="Product Image" />
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <div v-if="product.tag?.toLowerCase() == 'most popular'" class="mb-2">
                  <span class="py-1 px-4 font-family text-white" :style="'font-size: 18px; background-color: #F16565;'">
                    Most Popular
                  </span>
                </div>
                <div class="text-bold" :style="'font-size: 20px; color: #105992; line-height: 40px;'">
                  <span class="">{{ product.name }}</span>
                </div>
                <div class="my-3">
                  <span style="font-size: 15px; line-height: 1.5rem; color: #9e9e9e" class="text-grey-7 text-bold">
                    {{ product.ProductLineName }}
                  </span>
                </div>
                <div class="mt-3 text-bold font-family" :style="'color: #388E3C; font-size: 15px;'">
                  <span> You are saving
                    {{
                      product.mrp *
                      (product.quantity == 0 ? 1 : product.quantity) -
                      getPriceData(product) *
                      (product.quantity == 0 ? 1 : product.quantity) | currencyFilter
                    }}
                  </span>
                </div>
  
                <div class="d-flex justify-content-between">
                  <div class="d-flex mt-2">
                    <div class="mr-3">
                      <span class="text-bold" :style="'font-size: 22px; color: #044b9a'">
                        {{
                          Number(
                            getPriceData(product) *
                            (product.quantity == 0
                              ? 1
                              : product.quantity)
                          ) | currencyFilter
                        }}
                      </span>
                    </div>
                    <div class="mr-3">
                      <span class="mrp-value" :style="'color: #9e9e9e; font-size: 22px; text-decoration: line-through;'">
                        {{
                          (Number(product.mrp) *
                            (product.quantity == 0
                              ? 1
                              : product.quantity))
                          | currencyFilter
                        }}
                      </span>
                    </div>
                    <div class="text-bold mt-1">
                      <span class="" :style="'font-size: 18px; color: #108f55;'">
                        {{ getPercentageData(product) }}% Off
                      </span>
                    </div>
                  </div>
                  <div class="mt-2 mr-5">
                    <span class="font-family" :style="'color: #9e9e9e; font-size: 18px;'">
                      Rs. {{ getPriceData(product) }}/Unit
                    </span>
                  </div>
                </div>
  
                <div class="d-flex justify-content-between mt-3">
                  <div class="d-flex">
                    <q-btn @click="product.quantity--" class="mr-3 pd-btn minus-btn" :disabled="product.quantity == 0"
                     icon="remove"/>
                    <div class="mr-3" :style="'padding-top: 3px!important;'">
                      <div class="">
                        <input v-model="product.quantity" @input="handleInput(product)" class="square mr-5"
                        :min="0" :max="product.maxPurchaseLimit" />
                      </div>
                    </div>
                    <q-btn @click="product.quantity++" :disabled="disableIncrementButton(product)" class="pd-btn plus-btn"
                    icon="add"/>
                  </div>
                  <div class="mr-5">
                    <q-btn @click="addToCart(product)" :disabled="disableAddButton(product)"  outline class="add-cart custom-outline-btn ml-5" >
                      Add to Cart
                    </q-btn>
                  </div>
                </div>
                <div>
                  <div v-if="warningMaxLimit(product)" class="mt-4 text-red">
                    <p>{{ warningMaxLimit(product) }}</p>
                  </div>
                  <div v-if="product.quantity > product.maxPurchaseLimit &&
                    !warningMaxLimit(product)
                    " class="mt-4 text-red">
                    <p>
                      - Please Add {{ product.maxPurchaseLimit }} or Less
                      Quantities for this Product.
                    </p>
                  </div>
                  <div v-if="inBagQuantity(product) > 0" class="mt-4 text-red">
                    <p>
                      - Already added
                      {{ inBagQuantity(product) }} Quantity in Bag for
                      this Product.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <template>
              <div class="mt-4">
                <q-tabs v-model="selectedTab" inline-label class="text-white navs-tabs">
                  <q-tab class="tabs-label" name="Description" label="Description"  />
                  <q-tab class="tabs-label" name="Features" label="Features" />
                  <q-tab class="tabs-label" name="System Requirements" label="System Requirements" />
                  <q-tab class="tabs-label" name="Award" label="Award" />
                  <q-tab class="tabs-label" name="Terms & Conditions" label="Terms & Conditions" />
                </q-tabs>
              </div>
            </template>
            <q-separator class="line-separtor"  />

            <div v-if="selectedTab === 'Description'">
              <div class="mt-4 ml-3 text-h6">Product Description</div>
              <div class="p-4 mt-1 ml-4">
                  <template v-for="(sentence, index) in descriptionSentences">
                    <div>
                      <p class="preserve-spaces" style="margin-top: -10px; color: #666666">
                        {{ sentence }}
                      </p>
                      <br v-if="index < descriptionSentences.length - 1" />
                    </div>
                  </template>
              </div>
            </div>
            <div v-if="selectedTab === 'System Requirements'" class="mt-4 ml-3 text-h6">System Requirements</div>
            <div v-if="selectedTab === 'System Requirements'" class="mt-2 ml-4">
              <div class="p-2 " style="margin-bottom: 20px;">
                <div v-html="product.systemRequirements"></div>
              </div>
            </div>
            <div v-if="selectedTab === 'Terms & Conditions'" class="mt-4 ml-3 text-h6">Terms & Conditions</div>
            <div v-if="selectedTab === 'Terms & Conditions'" class="mt-2 ml-4">
              <div class="p-2 " style="margin-bottom: 20px;">
                <div v-html="product.terms"></div>
              </div>
            </div>
            <div v-if="selectedTab === 'Award'">
              <div class="mt-4 ml-3 text-h6">Award</div>
              <div class="p-3 ml-4 award-container">
                <div v-for="(award, index) in product.awards" :key="index" class="award-item">
                  <img :src="imageUrl(award)" alt="Award Image" class="p-5 award-image" />
                </div>
              </div>
            </div>
            <div v-if="selectedTab === 'Features'">
              <div class="mt-4 ml-3 text-h6">Product Features</div>
              <div class="q-pa-md p-3 text-gray accodions_list">
                <q-list bordered class="rounded-borders">
                  <template>
                    <q-expansion-item v-for="(featureSet, index) in product.features" :key="index" ref="expansionItems" :label="featureSet.name" @click="handleExpansion(index)" expand-separator class="item-text" :default-opened="featureSet.defaultOpened">
                    <q-card>
                        <div class="q-card mt-3 ml-3 mr-3 mb-3">
                          
                          <div class="row">
                            <div class="col-md-3 col-12 p-3" v-for="(item, index) in featureSet.list">
                              <div class="accodions_cards rounded-1" >
                                <div class="d-flex align-items-center justify-content-center my-2" v-if="item.image">
                                  <img :src="imageUrl(item.image)" class="img-fluid mx-auto accordion-image"
                                    alt="Accordion Image" />
                                </div>
                                <h5>{{ item.title }}</h5>
                                <p>{{ item.description }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </q-card>
                    </q-expansion-item>
                  </template>
                </q-list>
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import Constants from "../../Constants/Constant";

export default {
  name: "Products",

  data: function () {
    return {
      // awardTest : [
      //     "uploads/e50b2e8d333c53f0ee48849510b9c47c.png",
      //     "uploads/1b31b6c617a89adf31f098392afefd9f.png",
      //     "uploads/1b31b6c617a89adf31f098392afefd9f.png",
      //     "uploads/1b31b6c617a89adf31f098392afefd9f.png",
      //     "uploads/1b31b6c617a89adf31f098392afefd9f.png",
      //     "uploads/1b31b6c617a89adf31f098392afefd9f.png",
      // ],
      productId: this.$route.query.productId,
      OnlineProducts: [],
      productsUpdatedData: [],
      isItemOpen: [],
      cartData: [],
      product: null,
      features: [],
      awards: [],
      selectedTab: "Description"
    };
  },
  computed: {
    descriptionSentences() {
      if (this.product && this.product.description) {
        return this.product.description
          .split("- ")
          .filter((sentence) => sentence.trim() !== "");
      } else {
        return [];
      }
    },
  },

  created() {
    const savedCart = localStorage.getItem("cartProducts");
    if (savedCart) {
      this.cartData = JSON.parse(savedCart);
    }
    this.loadData();
  },

  methods: {
    goBack() {
      this.$router.push({
        path: '/Partners/Stock/Products', 
        query: { viewType: this.$route.query.viewType }
      });
  },
  handleExpansion(clickedIndex) {
      this.$refs.expansionItems.forEach((item, index) => {
        const shouldBeOpened = index === clickedIndex && !item.isCurrentlyOpened;
        if (shouldBeOpened) {
          item.show();
          item.isCurrentlyOpened = true; 
        } else {
          item.hide();
          item.isCurrentlyOpened = false; 
        }
      });
    },
    imageUrl(image) {
      const url = Constants.base_url + image;
      return url;
    },

    setOpenState(isOpen, index) {
      this.$set(this.isItemOpen, index, isOpen);
    },

    handleInput(product) {
      const remainingQuantity = product.maxPurchaseLimit - this.inBagQuantity(product);
      if (product.quantity < 0) {
        product.quantity = 0;
      } else if (product.quantity > remainingQuantity) {
        product.quantity = remainingQuantity;
        if (this.inBagQuantity(product) === 0) {
          this.$q.notify({
            position: 'top-right',
            message: `You can buy maximum ${product.maxPurchaseLimit} quantities. Only ${product.maxPurchaseLimit} items left.`,
          });
        } else if (product.maxPurchaseLimit === this.inBagQuantity(product)) {
          this.$q.notify({
            position: 'top-right',
            message: `You already added the maximum quantity of this product. You can't add more.`,
          });
        } else {
          this.$q.notify({
            position: 'top-right',
            message: `You can add up to ${remainingQuantity} ${remainingQuantity > 1 ? 'quantities' : 'quantity'} because you already added ${this.inBagQuantity(product)} ${this.inBagQuantity(product) > 1 ? 'quantities' : 'quantity'} in the bag.`,
          });
        }
      }
      product.quantity = Math.max(0, parseInt(product.quantity ? product.quantity : 0, 10));
    },

    getFeatureSetLabel(featureSet) {
      return featureSet.name;
    },

    getFeatureLabel(item) {
      return item.title; // You can customize this label as needed
    },

    inBagQuantity(product) {
      const existingProductIndex = this.cartData.findIndex(item => item.id === product.id);
      if (existingProductIndex !== -1) {
        return this.cartData[existingProductIndex].quantity;
      }
      return 0;
    },

    disableAddButton(product) {
      if ((Number(product.quantity) == 0) || (Number(product.quantity) > Number(product.maxPurchaseLimit))) {
        return true;
      } else {
        const existingProductIndex = this.cartData.findIndex(item => item.id === product.id);
        if (existingProductIndex !== -1) {
          const existProduct = this.cartData[existingProductIndex];
          if ((Number(existProduct.quantity) + Number(product.quantity)) > Number(product.maxPurchaseLimit)) {
            return true;
          }
        }
      }
      return false;
    },

    disableIncrementButton(product) {
      if (Number(product.quantity) >= Number(product.maxPurchaseLimit)) {
        return true;
      } else {
        const existingProductIndex = this.cartData.findIndex(item => item.id === product.id);
        if (existingProductIndex !== -1) {
          const existProduct = this.cartData[existingProductIndex];
          if ((Number(existProduct.quantity) + Number(product.quantity)) >= Number(product.maxPurchaseLimit)) {
            return true;
          }
        }
        return false;
      }
    },

    warningMaxLimit(product) {
      const foundProduct = this.cartData.find(c => c.id === product.id);
      if (foundProduct && product.quantity > (product.maxPurchaseLimit - foundProduct.quantity)) {
        if ((product.maxPurchaseLimit - foundProduct.quantity) == 0) {
          return `- You already added maximum quantity of this Product. You can't add more.`
        }
        return `- Please add ${product.maxPurchaseLimit - foundProduct.quantity} or less quantities for this Product.`;
      } else {
        return null;
      }
    },

    addToCart(product) {
      const productCopy = { ...product };
      const existingProductIndex = this.cartData.findIndex(item => item.id === product.id);
      if (existingProductIndex !== -1) {
        this.cartData[existingProductIndex].quantity += Number(product.quantity);
      } else {
        productCopy.quantity = Number(product.quantity);
        this.cartData.push(productCopy);
      }
      product.quantity = 0;
      localStorage.setItem('cartProducts', JSON.stringify(this.cartData));
      this.$q.notify({
        position: 'top-right',
        message: 'Product added to the cart successfully!',
      });
    },

    getPriceData(product) {
      try {
        const pricingObject = product.pricing.find(pricing => {
          const qtyFrom = parseInt(pricing.qtyFrom);
          const qtyUpTo = parseInt(pricing.qtyUpTo);
          if (product.quantity == 0) {
            return 1 >= qtyFrom && 1 <= qtyUpTo;
          } else {
            return product.quantity >= qtyFrom && product.quantity <= qtyUpTo;
          }
        });

        if (pricingObject) {
          return pricingObject.price;
        } else {
          const lowestPrice = product.pricing.reduce((minPrice, currentPrice) => {
            const price = parseInt(currentPrice.price);
            return price < minPrice ? price : minPrice;
          }, Infinity)
          return lowestPrice;
        }
      } catch (error) {
        console.error('Error fetching online products data', error);
      }
    },

    getPercentageData(product) {
      const price = this.getPriceData(product);
      const result = 100 - (price * 100) / product.mrp;
      return result.toFixed(0);
    },

    async loadData() {
      const apiUrl = Constants.api_url + "getProduct";
      try {
        const response = await axios.post(apiUrl, {
          productId: this.productId,
        });
        const product = response.data.data;
        if (product.features && product.features.length) {
            product.features.forEach((featureSet, index) => {
              featureSet.defaultOpened = index === 0;
          });
        }
        product.quantity = 0;
        this.product = product;
      } catch (error) {
        console.error("Error loading product data", error);
      }
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 1100px) {
  .main-container {
    max-width: 900px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 25px;
  }
}

@media only screen and (min-width: 1101px) and (max-width: 1280px) {
  .main-container {
    max-width: 1024px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 55px;
  }
}

@media only screen and (min-width: 1281px) and (max-width: 1780px) {
  .main-container {
    max-width: 1240px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 75px;
  }
}

@media only screen and (min-width: 1781px) {
  .main-container {
    max-width: 1050px;
    margin: 0 auto;
  }

  .main-image-set {
    margin-right: 90px;
  }
}

/* .main-container {
  max-width: 1024px;
  margin: 0 auto;
} */

.font-family {
  font-family: sans-serif;
}

.square {
  border: 1px solid #000;
  padding: 6px 12px 6px 12px;
  display: inline-block;
  background-color: white;
  width:65px
}

.text-price-value {
  color: #167e85;
}

.product-image {
  background-color: #e7eff2;
  height: 500px;
  width: 500px;
  margin-left: 200px;
}

.text-h6 {
  font-size: 26px;
  font-weight: 800;
  line-height: 2rem;
  letter-spacing: 0.0125em;
}

.text-gray {
  color: #666666;
}

.text-center {
  text-align: center;
  color: gray;
  font-size: 20px;
}

.bg-color {
  background-color: #e7eff2;
}

.award-image {
  border: 1px solid;
  border-color: lightgray;
  max-width: 100%;
  margin: 5px;
  border-radius: 5px;
  background-color: aliceblue;
}

.award-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.award-item {
  margin: 5px;
  box-sizing: border-box;
}

.award-image {
  border: 1px solid;
  border-color: lightgray;
  width: 300px;
  max-width: 100%;
}

.text-h5 {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal;
  margin-left: 608px;
}

.accodion_img {
  margin: 0 auto;
  height: 130px;
  width: 130px;
  border: 1px solid rgb(203, 202, 202);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(22, 126, 133, 0.40);
}

.accodion_img img {
  max-height: 90px;
  max-width: 90px;
}

.accordion_text {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

.accordion_content {
  border-top: 1px solid #dad8d8;
  background-image: linear-gradient(to bottom, #167e8566, #F4F6FA);
}

.q-item__section--main~.q-item__section--side index {
  color: white !important;
}

.accodions_list .q-expansion-item--expanded.accodion_items {
  background-color: #167E85 !important;
  color: white;
}

.q-expansion-item--expanded.accodion_items .q-expansion-item__toggle-icon.q-icon.material-icons.q-expansion-item__toggle-icon--rotated {
  color: white !important;
}

.icon-img-set {
  margin: 0 028px 0 5px;
}

.shop_card {
  position: relative;
}

.card_number {
  position: absolute;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #F16565;
  top: -4px;
  right: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  padding-top: 1px;
}

.icon_hover {
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* margin-left: 18px */
}

.accordion-image {
  max-width: 80px;
}

.accodions_cards {
  background-image: linear-gradient(#D4EAEC, #EEFAFE);
  border-radius: 4px;
  padding: 12px 24px;
}

.line-separtor {
  background-color: #105992;
  padding-top: 1px;
  margin: 0 18px;
}

.q-tab__indicator.absolute-bottom {
  left: 0;
  right: 0;
  bottom: 100px;
}
.accodions_cards h5 {
  color: #105992;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  padding-top: 18px;
  text-align: center;
}

.accodions_cards p {
  color: #212121;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  padding-top: 17px;
}

.navs-tabs [aria-selected="true"] {
  background-color: #105992;
  color: #FFFFFF !important;

}

.navs-tabs [aria-selected="true"] .tabs-label {
  font-weight: 700 !important;
}

.navs-tabs .tabs-label {
  color: #105992;
  bottom: -2px !important;
}

.q-expansion-item--collapsed {
  background-color: #F2F2F2;
}

.q-expansion-item--expanded {
  background-color: #F2F2F2;
}

.item-text {
  color: black;
  font-size: 18px;
  font-weight: 700;
  /* background-color: #F2F2F2; */
}
.image-container {
  height: 270px;
  width: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  overflow: hidden;
  background: #E7EFF2 !important;
}

.image-container img {
  max-height: 100%;
  max-width: 100%;
  object-fit: cover;
}

.icon_hover:hover {
  background-color: #EBEBEB;
}

.preserve-spaces {
  white-space: pre-line;
}

.square{
  right: 15px;
  height: 27px;
  text-align: center;
  color: #167e85;
  border: none;
  outline: none;
  font-size: larger;
  font-weight: bold;
  position: relative;
  margin-top: 3px;
  margin-left: -1px;
}

.plus-btn {
  height: 35px;
  width: 34px;
  color: #1e1f3d80 !important;
  background-color: transparent !important;
  border: 1px solid #1e1f3d4d !important;
  border-radius: 5px;
  margin-left: -82px;
  font-size: larger;
}

.minus-btn {
  height: 35px;
  width: 34px;
  color: #1e1f3d80 !important;
  background-color: transparent !important;
  border: 1px solid #1e1f3d4d !important;
  border-radius: 5px;
  font-size: larger;
}

.add-cart {
  height: 35px;
  text-transform: none;
  font-size: 14px;
  margin-left: 0px;
  border: solid #167e85 !important;
  width:180px;
}

.custom-outline-btn {
  color: #167e85 !important;
  border: #167e85 !important;
}

.custom-outline-btn:hover {
  background-color: #167e85 !important;
  color: #ffffff !important;
}



</style>
